import React from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

import PortalCard from "./PortalCard";
import InformCard from "./InformCard";
import ReportCard from "./ReportCards";
// import BannerImage from "./Banner";
import { Dropdown, Menu } from "antd";

import MilkIcon from "../../assets/icons/milk.svg";
import VagetIcon from "../../assets/icons/vaget.svg";
import ExerciseIcon from "../../assets/icons/exercise.svg";
import SweetIcon from "../../assets/icons/sweet.svg";
import MoreIcon from "../../assets/icons/more.svg";

import DocIcon from "../../assets/icons/doc.svg";
import BookIcon from "../../assets/icons/book_icon.svg";

import BannerForOtherDT from "../../assets/images/Hdesktop_content.png";
import BannerForOtherTB from "../../assets/images/Htablet_content.png";
import BannerForOtherMB from "../../assets/images/Hmobile_content.png";
import BannerForUserDT from "../../assets/images/Hdesktop.png";
import BannerForUserTB from "../../assets/images/Htablet.png";
import BannerForUserMB from "../../assets/images/Hmobile.png";

const getPortals = (roles, isStart) => [
  {
    topic: "ดื่มดี นมวัว",
    description: "วันละ 1-2 กล่อง",
    color: "#00B67F",
    icon: MilkIcon,
    link: "/article/milk",
  },
  {
    topic: "สุขชัวร์ เพิ่มผัก",
    description: "วันละ 6-12 ช้อนโต๊ะ",
    color: "#00B67F",
    icon: VagetIcon,
    link: "/article/veggie",
  },
  {
    topic: "รักออกกำลัง",
    description: "วันละอย่างน้อย 60 นาที",
    color: "#00B67F",
    icon: ExerciseIcon,
    link: "/article/move",
  },
  {
    topic: "หยุดยั้ง น้ำหวาน",
    description: "ไม่ดื่มน้ำหวาน",
    color: "#00B67F",
    icon: SweetIcon,
    link: "/article/drink",
  },
  {
    topic: roles.includes("student")
      ? "กรอกข้อมูลภาวะโภชนาการ"
      : "เช็กภาวะโภชนาการ",
    full: roles.includes("student"),
    color: "#8184F7",
    resFull: true,
    isTree: roles.length === 0,
    link: "/nutrition",
  },
  {
    topic: "ระดับรางวัล ",
    color: "#40B5FC",
    resFull: true,
    isTree: roles.length === 0,
    link: "/reward",
  },
  ...(roles.length === 0
    ? [
        {
          topic: "ทดลองเล่น ",
          color: "#FFA226",
          resFull: true,
          isTree: true,
          link: "/inform",
        },
      ]
    : []),
  ...(roles.includes("student")
    ? [
        {
          topic: "ขอทราบผล",
          color: "#FFA226",
          resFull: true,
          link: "/reportMonk", // TODO change link
        },
      ]
    : []),
];

const Rules = ({ isOther }) => (
  <RulesContainer isOther={isOther}>
    <RulesDescription to="/scoreRules">
      <RuleIcon src={DocIcon} />
      กติกาการแข่งขัน สร้างสุขภาพ
    </RulesDescription>
  </RulesContainer>
);

const Home = () => {
  const { role = [] } = useSelector((s) => s.auth.userInfo);
  console.log(role);
  const isAdmin = role.includes("admin");
  const isMonk = role.includes("monk") || role.includes("staff");
  const isStudent = role.includes("student");

  const isOther = !(isAdmin || isMonk || isStudent);

  const {
    currentWeek: weeks,
    currentStep: steps,
    isInformedToday,
    maxStep: maxSteps,
    currentScore,
    startDate,
    isInformedThisWeek,
    maxWeek,
    nextWeekDate,
  } = useSelector((s) => s.auth.informInfo);

  const isStart = weeks && weeks > 0;
  const isEnd = weeks && weeks >= maxWeek && isInformedThisWeek;

  return (
    <Container>
      <Background>
        <Banner isOther={isOther} id="homeBanner">
          <ImageContainer>
            <BannerImageDT src={isOther ? BannerForOtherDT : BannerForUserDT} />
            <BannerImageTB src={isOther ? BannerForOtherTB : BannerForUserTB} />
            <BannerImageMB src={isOther ? BannerForOtherMB : BannerForUserMB} />
          </ImageContainer>
          {/* <Banner /> */}
          {isOther && (
            <BannerDescriptionContainer>
              <BannerDescription>
                &nbsp;&nbsp;&nbsp;&nbsp;
                เว็บแอปพลิเคชันนี้ให้สามเณรบันทึกพฤติกรรมการฉัน
                อาหารและออกกำลังกายของตนเองสัปดาห์ละ 1 วัน เป็น
                ระยะเวลาติดต่อกัน 4-16 สัปดาห์ โดยมีสื่อให้ความรู้
                แรงบันดาลใจและระบุเป้าหมายชัดเจนในการ...
              </BannerDescription>
              <BannerDescriptionMore to="/description">
                {`เพิ่มเติม`} <More src={MoreIcon} />
              </BannerDescriptionMore>
            </BannerDescriptionContainer>
          )}
        </Banner>
        {!isOther && <Rules isOther={isOther} />}
        {isStudent && (
          <InformCard
            isStart={isStart}
            isEnd={isEnd}
            weeks={weeks}
            disable={!isStart || isEnd || isInformedThisWeek}
            currentScore={currentScore}
            startDate={startDate}
            nextWeekDate={nextWeekDate}
            isInformedThisWeek={isInformedThisWeek}
          />
        )}
        {(isAdmin || isMonk) && <ReportCard isStart={isStart} />}

        <PortalHeader>มาดูว่า 4 เป้าหมายมีอะไรบ้าง</PortalHeader>
        <PortalDescription>
          พร้อมความรู้ แรงบันดาลใจและตัวช่วย
        </PortalDescription>
        <PortalContainer>
          {getPortals(role, isStart).map((p) => (
            <PortalCard {...p} />
          ))}
        </PortalContainer>
        {isOther && <Rules isOther={isOther} />}
        <HowToContainer>
          <Dropdown
            overlay={
              <Menu>
                {(isStudent || isOther) && (
                  <Menu.Item
                    key={"downloadStudent"}
                    onClick={() => window.open("/คู่มือการใช้งาน (สามเณร).pdf")}
                  >
                    คู่มือการใช้งาน (สามเณร)
                  </Menu.Item>
                )}
                {(isMonk || isOther) && (
                  <Menu.Item
                    key={"downloadTeacher"}
                    onClick={() =>
                      window.open("/คู่มือการใช้งาน (พระอาจารย์).pdf")
                    }
                  >
                    คู่มือการใช้งาน (พระอาจารย์)
                  </Menu.Item>
                )}
                <Menu.Item
                  key={"suggestionLink"}
                  onClick={() =>
                    window.open(
                      "https://youtube.com/playlist?list=PL_pVH9ErekM_hQgpXgQGpy4lD-j-RYXbf"
                    )
                  }
                >
                  คลิปสาธิตการใช้งาน
                </Menu.Item>
              </Menu>
            }
            placement="topLeft"
            arrow
          >
            <HowToHelper>
              <HowToIcon src={BookIcon} />
              <HowToLabel>วิธีใช้งาน</HowToLabel>
            </HowToHelper>
          </Dropdown>
        </HowToContainer>
      </Background>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
`;

const Background = styled.div`
  position: relative;
  width: 100%;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-bottom: 40px;
  z-index: 2;

  ${responsive.tablet(css`
    max-width: unset;
    padding-bottom: 40px;
  `)}

  ${responsive.mobile(css`
    padding-bottom: 20px;
  `)}
`;

const Banner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1144px;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${responsive.tablet(css`
    max-width: unset;
  `)}
`;

const ImageContainer = styled.div`
  width: 100%;
  position: absolute;
`;

const BannerImage = styled.img`
  width: 100%;
  margin: 0;
  z-index: 1;
`;

const BannerImageDT = styled(BannerImage)`
  ${responsive.tablet(css`
    display: none;
  `)}
`;

const BannerImageTB = styled(BannerImage)`
  display: none;
  ${responsive.tablet(css`
    display: flex;
  `)}
  ${responsive.mobile(css`
    display: none;
  `)}
`;

const BannerImageMB = styled(BannerImage)`
  display: none;
  ${responsive.mobile(css`
    display: flex;
  `)}
`;

const BannerDescriptionContainer = styled.div`
  position: relative;
  margin-top: 159px;
  border-radius: 8px;
  background-color: white;
  max-width: 824px;

  z-index: 1;

  padding: 40px 24px 42px;

  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);

  ${responsive.tablet(css`
    max-width: 575px;
    margin-top: 19vw;

    padding: 30px 16px 32px;
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
    margin-top: 22.9vw;
    bottom: unset;

    padding: 14px 16px 16px;
  `)}
`;

const BannerDescription = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;

  color: #4b5768;

  ${responsive.tablet(css`
    font-size: 18px;
    line-height: 26px;
  `)}

  ${responsive.mobile(css`
    font-size: 14px;
    line-height: 21px;
  `)}
`;

const BannerDescriptionMore = styled(Link)`
  position: absolute;
  right: 24px;
  bottom: 40px;

  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: right;

  color: #fc6b4b;
  background-color: white;

  ${responsive.tablet(css`
    font-size: 16px;
    right: 16px;
    bottom: 29px;
  `)}

  ${responsive.mobile(css`
    font-size: 13px;
    right: 16px;
    bottom: 13px;
  `)}
`;

const More = styled.img`
  ${responsive.mobile(css`
    width: 22px;
  `)}
`;

const PortalHeader = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  line-height: 40px;

  text-align: right;
  letter-spacing: -0.02em;

  color: #058459;

  margin-top: 14px;
  z-index: 4;

  ${responsive.tablet(css`
    font-size: 28px;
    line-height: 34px;

    margin-top: 6px;
  `)}

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;

    margin-top: 3px;
  `)}
`;

const PortalDescription = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;

  text-align: right;

  color: #4b5768;

  margin-top: 4px;
  z-index: 4;

  ${responsive.tablet(css`
    font-size: 20px;
    line-height: 28px;
  `)}

  ${responsive.mobile(css`
    font-size: 16px;
    line-height: 26px;
  `)}
`;

const PortalContainer = styled.div`
  width: 911px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  margin-top: 32px;
  z-index: 4;

  ${responsive.tablet(css`
    width: calc(100% - 64px);

    margin-top: 24px;
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);

    margin-top: 8px;
  `)}
`;

const RulesContainer = styled.div`
  display: flex;
  max-width: 911px;
  width: ${(props) => (props.isOther ? "unset" : "100%")};
  margin: ${(props) => (props.isOther ? "18px 0 6px" : "315px 0 0")};
  z-index: 3;

  ${(props) =>
    responsive.tablet(css`
      max-width: unset;
      width: calc(100% - 64px);
      margin: ${props.isOther ? "15px 0 6px" : "37.78vw 0 0"};
    `)}

  ${(props) =>
    responsive.mobile(css`
      width: calc(100% - 32px);
      margin: ${props.isOther ? "14px 0 6px" : "43.73vw 0 0"};
    `)}
`;

const RulesDescription = styled(Link)`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 20px;

  text-align: right;
  text-decoration-line: underline;

  color: #fb633d;

  ${responsive.tablet(css`
    font-size: 22px;
  `)}

  ${responsive.mobile(css`
    font-size: 16px;
  `)}
`;

const RuleIcon = styled.img`
  margin-right: 6px;
  width: 32px;
`;

const HowToContainer = styled.div`
  margin-left: calc(100% - 104px);

  padding-right: 40px;

  position: sticky;
  bottom: 40px;

  cursor: pointer;
  z-index: 100;

  ${responsive.mobile(css`
    margin-left: calc(100% - 84px);
    padding-right: 20px;
    bottom: 20px;
  `)}
`;

const HowToHelper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 64px;
  height: 64px;

  background: #058459;

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
`;

const HowToIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-bottom: 3px;
`;

const HowToLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: right;

  color: #ffffff;
`;

export default Home;
